import Link from 'next/link'
export enum Variables {
    sky = 'sky',
    violet = 'violet',
    red = 'red',
    yellow = 'yellow',
    green = 'green',
    blue = 'blue',
    indigo = 'indigo',
    emerald = 'emerald',
    purple = 'purple',
    pink = 'pink',
    orange = 'orange'
}
export type TagProps = {
    name?: string
    variables: Variables
    slug: string
}
const Tag = ({ name, variables, slug }: TagProps) => {
    const colors: Record<Variables, string> = {
        [Variables.sky]:
            'bg-sky-500/20 text-sky-600 hover:text-sky-600! dark:bg-sky-500/20 dark:text-sky-500 dark:hover:text-sky-500',
        [Variables.violet]:
            'bg-violet-500/20 text-violet-600 hover:text-violet-600! dark:bg-violet-500/20 dark:text-violet-500 dark:hover:text-violet-500',
        [Variables.red]:
            'bg-red-500/20 text-red-600 hover:text-red-600! dark:bg-red-500/20 dark:text-red-500 dark:hover:text-red-500',
        [Variables.yellow]:
            'bg-yellow-500/20 text-yellow-600 hover:text-yellow-600! dark:bg-yellow-500/20 dark:text-yellow-500 dark:hover:text-yellow-500',
        [Variables.green]:
            'bg-green-500/20 text-green-600 hover:text-green-600! dark:bg-green-500/20 dark:text-green-500 dark:hover:text-green-500',
        [Variables.blue]:
            'bg-blue-500/20 text-blue-600 hover:text-blue-600! dark:bg-blue-500/20 dark:text-blue-500 dark:hover:text-blue-500',
        [Variables.indigo]:
            'bg-indigo-500/20 text-indigo-600 hover:text-indigo-600! dark:bg-indigo-500/20 dark:text-indigo-500 dark:hover:text-indigo-500',
        [Variables.emerald]:
            'bg-emerald-500/20 text-emerald-600 hover:text-emerald-600! dark:bg-emerald-500/20 dark:text-emerald-500 dark:hover:text-emerald-500',
        [Variables.purple]:
            'bg-purple-500/20 text-purple-600 hover:text-purple-600! dark:bg-purple-500/20 dark:text-purple-500 dark:hover:text-purple-500',
        [Variables.pink]:
            'bg-pink-500/20 text-pink-600 hover:text-pink-600! dark:bg-pink-500/20 dark:text-pink-500 dark:hover:text-pink-500',
        [Variables.orange]:
            'bg-orange-500/20 text-orange-600 hover:text-orange-600! dark:bg-orange-500/20 dark:text-orange-500 dark:hover:text-orange-500'
    }
    return (
        <p
            title={name}
            className={`${colors[variables]} inline-block rounded-full px-2.5 py-1 text-xs font-medium transition-all`}
        >
            <span>{name}</span>
        </p>
    )
}

export default Tag
